import axios from "../axiosInstance";

class DriverService {
  async getDriverListByName() {
    return axios.get(`drivers`);
  }
}

export default new DriverService();
